import React from 'react';
import PropTypes from "prop-types";
import Select, { components } from 'react-select';
import {getFormInputCssClass, hasMessage} from "../../../util/FormUtil";
import {fetchResponseHandler,extractMessage} from "../../../util/FetchUtil";
import {PROP_NAME_IS_POSTAL_CODE_SABRIX} from "./PostalCodeInputComponent";

export const PROP_NAME_COUNTRY = "country";
export const PROP_NAME_COUNTRY_OPTIONS = "countryOptions";
export const COUNTRY_CODE_US = 'US';
export const COUNTRY_CODE_CANADA = 'CA';
export const DEFAULT_COUNTRY_CODE = COUNTRY_CODE_US;


// TODO Externalize react-select override components to some commons js ? (currently only used here and PostalCode)

export const ReactSelectEmptyIndicatorSeparator = () => null;  // remove the separator bar

export const ReactSelectDropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <div className="clickable icon__wrapper icon__wrapper--right" style={{top: '8px'}}>
                <i className="fa fa-caret-down" />
            </div>
        </components.DropdownIndicator>
    );
};

class CountryInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            countryOptions: []
        };
        this.findCountries = this.findCountries.bind(this);
        this.findCountryByIp = this.findCountryByIp.bind(this);
        this.loadCountryOptions = this.loadCountryOptions.bind(this);
        this.refreshFormState = this.refreshFormState.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.setPostalCodeSabrix = this.setPostalCodeSabrix.bind(this);
        this.setValue = this.setValue.bind(this);
        this.checkRequired = this.checkRequired.bind(this);
        this.validate = this.validate.bind(this);

        const PROP_DATA = {};
        PROP_DATA[PROP_NAME_COUNTRY] = { label: "Country"};
        this.PROP_DATA = PROP_DATA;
    }

    componentDidMount() {
        this.loadCountryOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {data} = this.props;
        const prevData = prevProps.data;

        if (data[PROP_NAME_COUNTRY_OPTIONS] !== prevData[PROP_NAME_COUNTRY_OPTIONS]) {
            this.refreshFormState(data);
            return;
        }

        const countryCode = data[PROP_NAME_COUNTRY];
        const prevCountryCode = prevData[PROP_NAME_COUNTRY];
        if (countryCode !== prevCountryCode) {  // on Country change - reset the postal code
            this.setPostalCodeSabrix(countryCode);
        }
    }

    loadCountryOptions() {
        const countryCode = this.props.data[PROP_NAME_COUNTRY];
        this.findCountries();
        this.setPostalCodeSabrix(countryCode);  // TODO conditional ? not necessary for Registration (where Country only)
        if (!countryCode) {
            this.findCountryByIp();
        }
    }

    // Restore the country options on form refresh
    refreshFormState(data) {
        const countryCodeOptions = data[PROP_NAME_COUNTRY_OPTIONS];
        if (countryCodeOptions === undefined || countryCodeOptions === null) {
            this.loadCountryOptions();
        }
    }

    findCountryByIp(){
        const {skipIpStackServiceCall} = this.props;
        //skipIpStackServiceCall is a reloadable property that applies only for EBS workflow
        if(skipIpStackServiceCall){
            this.setValue(DEFAULT_COUNTRY_CODE);
        }else{
            this.props.userDataService.findCountryByIp()
                .then((response) => { return response ? response.json() : null; })
                .then((data) => {
                    let countryCode = DEFAULT_COUNTRY_CODE;
                    if (data && data.country_code) {
                        countryCode = data.country_code;
                    }
                    this.setValue(countryCode);
                })
                .catch((error) => {
                    console.log("Error while finding country by IP: " + error);
                });
        }
    }

    findCountries() {
        this.props.userDataService.findCountries()
            .then(fetchResponseHandler)
            .then((countryOptions) => {
                this.setState({ countryOptions: countryOptions });
                this.props.setFormState({
                    property: PROP_NAME_COUNTRY_OPTIONS,
                    data: countryOptions
                });
            })
            .catch((e) => {
                const message = extractMessage(e);
                console.log("Error while looking up countries: " + message);
            })
        ;
    }

    setPostalCodeSabrix(country) {
        const countryCode = country || DEFAULT_COUNTRY_CODE;
        this.props.userDataService.findPostalCodesByCountry({countryCode, input: ''})
            .then(fetchResponseHandler)
            .then((postalCodes) => {
                this.props.setFormState({
                    property: PROP_NAME_IS_POSTAL_CODE_SABRIX,
                    data: (postalCodes.data && postalCodes.data.length > 0)
                });
            })
            .catch((e) => {
                const message = extractMessage(e);
                console.log("Error while looking up postalCodes: " + message);
            });
    }

    setValue(e){
        if (e) {    // backspace on empty search is null
            let value = typeof(e) === "string" ? e : e.code;
            this.validate(value);
        } else {
            this.validate(DEFAULT_COUNTRY_CODE);    // on Clear - set to Default value
        }
    }

    validate(value){
        const {required, setFormState} = this.props;
        const postalCodePropInfo = this.PROP_DATA[PROP_NAME_COUNTRY];
        // meta - reset everything
        const newMetadata = {valid: true, dirty: true, message: null};
        this.checkRequired(value, postalCodePropInfo, newMetadata, required);
        setFormState(
            {property: PROP_NAME_COUNTRY, data: value, metadata: { ...newMetadata }}
        );
    }

    checkRequired(value, propInfo, metadata, required){
        metadata.valid = !required || (value && value.trim().length > 0);
        if (! metadata.valid){
            metadata.message = propInfo.label + " is required";
        }
        return metadata.valid;
    }


    setDirty(){
        this.validate(this.props.data[PROP_NAME_COUNTRY]);
    }


    render(){
        const { data, metadata, readOnly, required } = this.props;
        const countryCode = data[PROP_NAME_COUNTRY] || "";
        const countryOptions = this.state.countryOptions || [];

        const requiredClassName = required ? "" : " optional";
        const fieldClassNameAttr = getFormInputCssClass(metadata, PROP_NAME_COUNTRY);

        const countryPropInfo = this.PROP_DATA[PROP_NAME_COUNTRY];

        return (
            <div className="form-fields">
                <div className={"grid__col-md-6 grid__col-sm-12" + requiredClassName}>
                    <label htmlFor={PROP_NAME_COUNTRY}>{countryPropInfo.label}</label>
                    {/* TODO as read-only */}
                    <Select
                        className={"select-input--large react-select-container" + fieldClassNameAttr}
                        //className='react-select-container'
                        classNamePrefix="react-select"
                        components={{ IndicatorSeparator: ReactSelectEmptyIndicatorSeparator,
                            DropdownIndicator: ReactSelectDropdownIndicator }}
                        getOptionLabel={({ description }) => description}
                        getOptionValue={({ code }) => code}
                        id='country'
                        isDisabled={readOnly}
                        noOptionsMessage={() => 'No results found'}
                        onChange={(e) => this.setValue(e)}
                        onBlur={() => this.setDirty}
                        options={countryOptions}
                        placeholder="Select or Type..."
                        value={countryOptions.filter(({ code }) => code === countryCode)}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_COUNTRY) &&
                        <div className="error">{metadata[PROP_NAME_COUNTRY].message}</div>
                    }
                </div>
            </div>
        );
    }
}

CountryInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    readOnly: PropTypes.object,
    userDataService: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired
};

export default CountryInputComponent;